import { useRef, useEffect, createContext, useContext, useState } from "react";

const SessionContext = createContext();
export const SessionProvider = ({ children }) => {
  const [userLogin, setUserLogin] = useState(null);
  const [loading, setLoading] = useState(true);
  const apiUrl = import.meta.env.VITE_API_URL_MAIN;
  const initialized = useRef(false);
  const mainSiteUrl = import.meta.env.VITE_MAIN_SITE_URL;
  const [status, setStatus] = useState(null);
  const [showStatus, setShowStatus] = useState(false);
  const [statusTrigger, setStatusTrigger] = useState(0);
  const [log_minimized, setLog_minimized] = useState(false);
  const [siteCount, setSiteCount] = useState(null);
  const [siteFilters, setSiteFilters] = useState({
    filterSubmitted: "",
    filterActive: "",
    filterCompleted: false,
    filterEmptyAddress: false,
    filterNoUsersAssigned: false,
    filterEmptyGateNumber: false,
    filterHasPST: false,
    filterIsOld: false,
    filterHasBudgetLines: false,
  });
  const checkUserLogin = async () => {


    try {
      const time = new Date().getTime();
      const response = await fetch(`${mainSiteUrl}wp-json/monthly-invoices/v1/check-user-login?v=${time}`, {
        credentials: "include",// important!
      });

      if (response.ok) {
        const data = await response.json();
        if (!data.session_token) {
          return;
        }
        const response3 = await fetch(`${apiUrl}command=verify_sid&sid=${data.session_token}&email=${data.user_email}`, {
          credentials: "include",
        });
        if (response3.ok) {
          const data3 = await response3.json();
          if (!data3.success) {
            console.log(data3.error);
            return;
          }
          else {
            //success
            if (data.isAdmin) {
              let datatemp = data;
              datatemp.modified_at = data3.modified_at ?? false;
              setUserLogin(datatemp);
              setSiteCount(true);
              return;
            }

            //get the ready only status
            let datatemp = data;
            datatemp.read_only = data3.read_only ?? false;
            setUserLogin(datatemp);
            //check if user has access
            const response4 = await fetch(`${apiUrl}command=user_sites_count&user_email=${datatemp.user_email}`, {
              credentials: "include",
            });
            if (response4.ok) {
              const user_sites = await response4.json();
              setSiteCount(user_sites);
            }
          }
        }



      } else {
        setUserLogin(null);
      }
    } catch (error) {
      console.error("Session check failed", error);
      setUserLogin(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      checkUserLogin(); // only once on mount
    }
    let interval = setInterval(checkUserLogin, 300000); // every 5 minutes
    return () => clearInterval(interval);
  }, []);




  return (
    <SessionContext.Provider value={{
      userLogin,
      setUserLogin,
      loading,
      status,
      setStatus,
      showStatus,
      setShowStatus,
      statusTrigger,
      setStatusTrigger,
      siteFilters,
      setSiteFilters,
      log_minimized,
      setLog_minimized,
      siteCount
    }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
